import ReadOnlyOdataServiceBase from "@/core/services/OdataReadOnlyServiceBase";


class ClientPagesService extends ReadOnlyOdataServiceBase {

    static code = "204";
    code = "204";

    constructor () {

        super({
            sourcePath: "client-pages",
        });

    }

}

export default ClientPagesService;
